import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { testimonialsContent } from "../../data/testimonialsContent";
import SectionYellowTitle from "../common/SectionYellowTitle";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WistiaVideo from "../common/WistiaVideo";
import SectionMainTitle from "../common/SectionMainTitle";

const TestimonialsSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const validTestimonials = testimonialsContent.allTestimonials.filter(
    (t) => t.video.wistiaId
  );

  return (
    <Box
      sx={{
        textAlign: "center",
        my: { xs: 4, md: 8 },
        backgroundColor: theme.palette.background.default,
        position: "relative",
        "& .slick-prev, & .slick-next": {
          zIndex: 1,
          top: "45%",
          transform: "translateY(-50%)",
          width: isMobile ? 30 : 40,
          height: isMobile ? 30 : 40,
        },
        "& .slick-prev": {
          left: isMobile ? "-10px" : "-40px",
        },
        "& .slick-next": {
          right: isMobile ? "-10px" : "-40px",
        },
        "& .slick-dots li button:before": {
          color: theme.palette.primary.main,
        },
      }}
    >
      <Container maxWidth="lg">
        <SectionYellowTitle title={testimonialsContent.sectionLabel} />

        <SectionMainTitle title={testimonialsContent.title} mb={4} />

        <Slider {...settings}>
          {validTestimonials.map((t, i) => (
            <Box key={i} sx={{ px: { xs: 1, sm: 2 }, my: 4 }}>
              <WistiaVideo mediaId={t.video.wistiaId} />
              <Typography variant="body1" mt={4} fontWeight={600}>
                {t.video.title}
              </Typography>
              <Typography
                variant="body2"
                color="grey.400"
                sx={{ fontStyle: "italic" }}
              >
                {t.text.role}
              </Typography>
            </Box>
          ))}
        </Slider>

        <Button
          variant="contained"
          color="primary"
          href={testimonialsContent.buttonHref}
          sx={{ mt: 6 }}
        >
          {testimonialsContent.button}
        </Button>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;
